<script context="module">

    import { get } from "svelte/store";
    import { sessionId } from "../utils/store";
    import { getLocalSessionId } from "../utils/session";


    let USER_AGENT = navigator.userAgent;

    export const errorReasons = {
        'not_found': 'Account existiert nicht',
        'inactive': 'Bitte kontaktieren Sie unseren Support',
        'not_native': 'TODO',
        'password_incorrect': 'Falsches Passwort',
        'ratelimit': 'Bitte versuchen Sie es später nochmals',
        'fill_fields': 'Bitte füllen Sie alle Felder aus',
        'invalid_email': 'Bitte überprüfen Sie Ihre E-Mail-Adresse',
        'missing_params': 'Unerwarteter Fehler aufgetreten',
        'email_exists': 'Account mit dieser E-Mail-Adresse existiert bereits',
        'password_length': 'Mindestlänge Passwort sind 8 Zeichen',
        'unexpected_error_plans': 'Etwas ist schiefgelaufen. Bitte versuchen Sie es später nochmals.',
        'no_available': 'Sie können keine weiteren Standorte registrieren',
        'no_integrations': 'Bitte verlinken Sie mindestens ein Portal',
        'max_integrations': 'Sie haben Ihre maximale Anzahl an verlinkten Portalen erreicht'
    };


    let refreshLocalSessionId = () => {

        let localSessionId = get(sessionId);

        if (!localSessionId || localSessionId === '') {

            sessionId.set(getLocalSessionId());
        }

        USER_AGENT = navigator.userAgent;

    };


    export const sessionCheck = async () => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/auth/v1/session', {

            method: 'post',

            headers: {
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId)
            }

        }).then((response) => {

            return response.json();

        }).then((data) => {

            // TODO: What if failed?
            if (data['status'] !== 'success') {

                return false;
            }

            return data['verified'];

        });

    };

    export const login = async (email, password) => {

        return fetch(window.apiUrl + '/auth/v1/login', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT
            }),

            body: JSON.stringify({
                'email': email,
                'password': password
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const logout = async () => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/auth/v1/logout', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId)
            }),

            body: JSON.stringify({})

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const register = async (email, contact, password) => {

        return fetch(window.apiUrl + '/auth/v1/register/user', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT
            }),

            body: JSON.stringify({
                'email': email,
                'contact': contact,
                'password': password
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const resetPasswordCode = async (email) => {

        return fetch(window.apiUrl + '/auth/v1/reset/code', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT
            }),

            body: JSON.stringify({
                'email': email,
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    }

    export const resetPasswordSave = (code, email, password) => {

        return fetch(window.apiUrl + '/auth/v1/reset/save', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT
            }),

            body: JSON.stringify({
                'email': email,
                'password': password,
                'code': code
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    }

    export const plansMonthly = async (currency) => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/auth/v1/payment/plans/monthly', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId)
            }),

            body: JSON.stringify({
                'currency': currency
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const plansTiered = async (currency, tier) => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/auth/v1/payment/plans/tiered', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId)
            }),

            body: JSON.stringify({
                'currency': currency,
                'tier': tier
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const getCouponInfo = async (code) => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/auth/v1/payment/coupon/info', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId)
            }),

            body: JSON.stringify({
                'code': code
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const userProfile = async () => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/auth/v1/profile', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId)
            }),

            body: JSON.stringify({})

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const userProfileSave = async (profile) => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/auth/v1/profile/save', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId)
            }),

            body: JSON.stringify({
                'profile': profile
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const userPasswordChange = async (current, password) => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/auth/v1/profile/password/change', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId)
            }),

            body: JSON.stringify({
                'current': current,
                'password': password
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const userSupportCreate = async (supportForm) => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/auth/v1/profile/support/create', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId)
            }),

            body: JSON.stringify({
                'supportform': supportForm
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const getStripePublickey = async () => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/auth/v1/payment/publickey', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId)
            }),

            body: JSON.stringify({})

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const customerCreate = async (planId, paymentMethod, email, numLocations, currency, coupon) => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/auth/v1/payment/customer/create', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId)
            }),

            body: JSON.stringify({
                'planid': planId,
                'paymentmethod': paymentMethod,
                'email': email,
                'numlocations': numLocations,
                'currency': currency,
                'coupon': coupon
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const customerUpdate = async (paymentMethod) => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/auth/v1/payment/customer/update', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId)
            }),

            body: JSON.stringify({
                'paymentmethod': paymentMethod
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const customerUpdateConfirm = async (paymentMethod) => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/auth/v1/payment/customer/update/confirm', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId)
            }),

            body: JSON.stringify({
                'paymentmethod': paymentMethod
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const getSubscription = async (subscriptionId) => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/auth/v1/payment/subscription', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId)
            }),

            body: JSON.stringify({
                'subscriptionid': subscriptionId
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const checkSubscription = async () => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/auth/v1/payment/subscription/check', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId)
            }),

            body: JSON.stringify({})

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const changeSubscription = async (planId, numLocations) => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/auth/v1/payment/subscription/change', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId)
            }),

            body: JSON.stringify({
                'planid': planId,
                'numlocations': numLocations
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const cancelSubscription = async () => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/auth/v1/payment/subscription/cancel', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId)
            }),

            body: JSON.stringify({})

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const paymentInfo = async (scope) => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/auth/v1/payment/info', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId)
            }),

            body: JSON.stringify({
                'scope': scope
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const updateUserStatus = async (userStatus) => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/auth/v1/status/user/update', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId)
            }),

            body: JSON.stringify({
                'status': userStatus
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const createProperty = async (businessType, details) => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/auth/v1/property/create', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId)
            }),

            body: JSON.stringify({
                'businesstype': businessType,
                'details': details
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const saveProperty = async (propertyId, businessType, details, permissions) => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/auth/v1/property/save', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId),
                'pid': propertyId
            }),

            body: JSON.stringify({
                'businesstype': businessType,
                'details': details,
                'permissions': permissions
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const disableProperty = async (propertyId) => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/auth/v1/property/disable', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId),
                'pid': propertyId
            }),

            body: JSON.stringify({})

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const getProperty = async (propertyId) => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/auth/v1/property', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId)
            }),

            body: JSON.stringify({
                'propertyid': propertyId
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const listProperties = async () => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/auth/v1/property/list', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId)
            }),

            body: JSON.stringify({})

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const integrationDelete = async (propertyId, platform) => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/auth/v1/integrations/delete', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId),
                'pid': propertyId
            }),

            body: JSON.stringify({
                'platform': platform
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const tripadvisorSearch = async (query) => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/auth/v1/integrations/tripadvisor/search', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId)
            }),

            body: JSON.stringify({
                'query': query
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const tripadvisorSet = async (propertyId, name, address, url) => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/auth/v1/integrations/tripadvisor/set', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId),
                'pid': propertyId
            }),

            body: JSON.stringify({
                'name': name,
                'address': address,
                'url': url
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const googleAuth = async (propertyId, token) => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/auth/v1/integrations/google/auth', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId),
                'pid': propertyId
            }),

            body: JSON.stringify({
                'token': token
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const googleLocations = async (propertyId) => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/auth/v1/integrations/google/locations', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId),
                'pid': propertyId
            }),

            body: JSON.stringify({})

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const googleSet = async (propertyId, location) => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/auth/v1/integrations/google/set', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId),
                'pid': propertyId
            }),

            body: JSON.stringify({
                'location': location
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const facebookAuth = async (propertyId, token, fbuid) => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/auth/v1/integrations/facebook/auth', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId),
                'pid': propertyId
            }),

            body: JSON.stringify({
                'token': token,
                'fbuid': fbuid
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const facebookPages = async (propertyId) => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/auth/v1/integrations/facebook/pages', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId),
                'pid': propertyId
            }),

            body: JSON.stringify({})

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const facebookSet = async (propertyId, page) => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/auth/v1/integrations/facebook/set', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId),
                'pid': propertyId
            }),

            body: JSON.stringify({
                'page': page
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    /**
     * DATA HANDLERS
     */

    export const dataAvailable = async (propertyId, chartId) => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/data/v1/hasdata', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId),
                'pid': propertyId
            }),

            body: JSON.stringify({
                'chartid': chartId
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const getDashboardData = async (propertyId) => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/data/v1/dashboard', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId),
                'pid': propertyId
            }),

            body: JSON.stringify({})

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };


    export const getChart = async (propertyId, chartId, chartType, options) => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/data/v1/chart', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId),
                'pid': propertyId
            }),

            body: JSON.stringify({
                'chartid': chartId,
                'charttype': chartType,
                'options': options,
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const getFiltered = async (propertyId, chartId, chartType, options) => {

        refreshLocalSessionId();

        return fetch(window.apiUrl + '/data/v1/filtered', {

            method: 'post',

            headers: new Headers({
                'Content-Type': 'application/json',
                'Device-Type': 'Development',
                'User-Agent': USER_AGENT,
                'sid': get(sessionId),
                'pid': propertyId
            }),

            body: JSON.stringify({
                'chartid': chartId,
                'charttype': chartType,
                'options': options,
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

export const searchKeyword = async (query, propertyId) => {

    refreshLocalSessionId();

    if (query === '') {

        return;
    }

    return fetch(window.apiUrl + '/data/v1/keywords/search', {

        method: 'post',

        headers: {
            'Content-type': 'application/json',
            'Device-Type': 'Development',
            'User-Agent': USER_AGENT,
            'sid': get(sessionId),
            'pid': propertyId
        },

        body: JSON.stringify({
            query: query
        })

    }).then((response) => {

        return response.json();

    }).then((data) => {

        return data;

    });

};

export const getReviews = async (propertyId) => {

    refreshLocalSessionId();

    return fetch(window.apiUrl + '/data/v1/table', {

        method: 'post',

        headers: {
            'Content-type': 'application/json',
            'Device-Type': 'Development',
            'User-Agent': USER_AGENT,
            'sid': get(sessionId),
            'pid': propertyId
        },

        body: JSON.stringify({})

    }).then((response) => {

        return response.json();

    }).then((data) => {

        return data;

    });


};



</script>
